import { Subscription } from 'rxjs'
import { isReportLoadingState } from './../reports.selectors'
import { CreateReportRequest } from './../reports.actions'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { FormGroup, FormBuilder, FormControl } from '@angular/forms'

@Component({
  selector: 'app-business-licence-defaulters',
  templateUrl: './business-licence-defaulters.component.html',
  styleUrls: ['./business-licence-defaulters.component.css'],
})
export class BusinessLicenceDefaultersComponent implements OnInit, OnDestroy {
  public form: FormGroup
  public isLoading: boolean
  private state$: Subscription

  constructor(private store: Store<any>, private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      type: new FormControl('businessDefaulters'),
      filename: new FormControl('Business Licence Defaulters'),
    })

    this.state$ = this.store
      .pipe(select(isReportLoadingState))
      .subscribe((isLoading: boolean) => {
        this.isLoading = isLoading
      })
  }

  createReport() {
    this.store.dispatch(new CreateReportRequest(this.form.value))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }
}
